import { setConfiguration } from "react-grid-system";

require("intersection-observer");

import i18nProvider from "./i18n-provider";

setConfiguration({
  breakpoints: [612, 786, 1024, 1260],
  containerWidths: [576, 768, 992, 1200]
});

export const wrapPageElement = i18nProvider;
